// extracted by mini-css-extract-plugin
export default {"container":"R0-z"};